let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5uCUY")).then(() => parcelRequire('1ot39'));